
  <!-- <div class="col-md-3">
    <ul class="">
      <li><a class="dropdown-item">Regular link</a></li>
      <li><a class="dropdown-item">Active link</a></li>
      <li><a class="dropdown-item">Another link</a></li>
    </ul> -->

  <!-- <eas-side-menu slot="side" [groupedmenudata] = "groupedmenudata"
  [shoulddisplay] = "shoulddisplay" [selectedmenuitem] = "selectedmenuitem"
  [shoulddisplaysection] = "shoulddisplaysection"
  (sidemenuItemClicked)="onSidemenuItemClicked($event)"></eas-side-menu> -->

  <!-- </div> -->

 
<router-outlet></router-outlet>


